var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('coupons-info',{attrs:{"plan":_vm.user.plan,"campaigns":_vm.campaigns,"coupons":_vm.userCoupons,"timezone":_vm.user.timezone,"is-coupon-code":""}},[_vm._v("\n        クーポン\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }